import React from "react";
import styles from "./Artwork.module.css";

// 2026 artwork componenten
export const LeafRed = ({ className, style }) => (
  <img src="/img/artwork/leaf-red.png" alt="" className={`${styles.artwork} ${styles.leafRed} ${className || ''}`} style={style} />
);

export const LeafRed2 = ({ className, style }) => (
  <img src="/img/artwork/leaf-red-2.png" alt="" className={`${styles.artwork} ${styles.leafRed2} ${className || ''}`} style={style} />
);

export const LeafDate = ({ className, style }) => (
  <img src="/img/artwork/leaf-date.png" alt="" className={`${styles.artwork} ${styles.leafDate} ${className || ''}`} style={style} />
);

export const FlowerOrange = ({ className, style }) => (
  <img src="/img/artwork/flower-orange.png" alt="" className={`${styles.artwork} ${styles.flowerOrange} ${className || ''}`} style={style} />
);

export const FlowerOrangePlant = ({ className, style }) => (
  <img src="/img/artwork/flower-orange-plant.png" alt="" className={`${styles.artwork} ${styles.flowerOrangePlant} ${className || ''}`} style={style} />
);

export const FlowerBluePlant = ({ className, style }) => (
  <img src="/img/artwork/flower-blue-plant.png" alt="" className={`${styles.artwork} ${styles.flowerBluePlant} ${className || ''}`} style={style} />
);

export const FlowerBlue = ({ className, style }) => (
  <img src="/img/artwork/flower-blue.png" alt="" className={`${styles.artwork} ${styles.flowerBlue} ${className || ''}`} style={style} />
);

export const WaveBlue = ({ className, style }) => (
  <img src="/img/artwork/wave-blue.png" alt="" className={`${styles.artwork} ${styles.waveBlue} ${className || ''}`} style={style} />
);

export const WaveRed = ({ className, style }) => (
  <img src="/img/artwork/wave-red.png" alt="" className={`${styles.artwork} ${styles.waveRed} ${className || ''}`} style={style} />
);

const Artwork = () => {
  return null;
};

export default Artwork;
